<template>
  <div>
    myShare我的分享
  </div>
</template>

<script>
export default {
  name: "myShare",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>